import React from "react";
import { AiOutlineLogout } from "react-icons/ai";
import { Container, Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";
import { GetToken } from "../getToken";
import axios from "axios";
import { Link } from "react-router-dom";
import { SurveyNote, companyLogoSrc } from "../../common/DateFormat";
import Cookies from "js-cookie";
import logo from "../../../assets/img/logo.png";

const Header = ({ userSurveys, surveyDetails, BASE_URL, CookieURL }) => {
  const { REACT_APP_BASE_URL, REACT_APP_API_URL, REACT_APP_WEBSITE_URL, REACT_APP_CookieURL } =
    process.env;

  const logout = () => {
    Swal.fire({
      title: "Are you sure you want to logout?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: `Logout`,
      cancelButtonText: `Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        var token = GetToken();
        axios
          .get(`${REACT_APP_API_URL}/logout`, {
            headers: { Authorization: token },
          })
          .then((result) => {
            if (result.status === 200) {
              sessionStorage.clear();
              Cookies.remove("AuthToken", { domain: `${REACT_APP_CookieURL}` });
              window.location = REACT_APP_BASE_URL + "/login";
            }
          })
          .catch((err) => {
            sessionStorage.clear();
            window.location = REACT_APP_BASE_URL + "/login";
          });
      }
    });
  };

  return (
    <div className="sticky_header">
      {/* ── TOP NAV BAR ── */}
      <div className="analytics-header">
        <Container fluid>
          <div className="analytics-header-inner">
            {/* Left: Logo */}
            <div className="analytics-header-logo">
              <Link to={{ pathname: `${REACT_APP_WEBSITE_URL}` }} target="_blank">
                <img src={logo} alt="CENSUS by OpenEyes" className="nav-logo" />
              </Link>
            </div>

            {/* Right: company logo + actions */}
            <div className="analytics-header-right">
              {surveyDetails?.companyLogoURL &&
                surveyDetails.companyLogoURL !== "" && (
                  <div className="analytics-company-logo">
                    <img
                      src={companyLogoSrc(surveyDetails.companyLogoURL)}
                      alt="Company Logo"
                      className="nav-logo"
                    />
                  </div>
                )}

              {userSurveys && userSurveys.length > 1 && (
                <Dropdown>
                  <Dropdown.Toggle
                    id="survey-switch-dropdown"
                    className="analytics-change-survey-btn"
                  >
                    Change Survey
                  </Dropdown.Toggle>
                  <Dropdown.Menu className="analytics-dropdown-menu">
                    {userSurveys.map((survey, index) => (
                      <Dropdown.Item
                        href="#"
                        key={index}
                        onClick={() => (window.location = `${survey.SurveyId}`)}
                        dangerouslySetInnerHTML={{ __html: survey.SurveyName }}
                      />
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              )}

              <button className="analytics-logout-btn" onClick={() => logout()}>
                <AiOutlineLogout />
                <span>Logout</span>
              </button>
            </div>
          </div>
        </Container>
      </div>

      {/* ── SURVEY TITLE BAR ── */}
      <div className="analytics-survey-bar">
        <Container fluid>
          <div className="analytics-survey-bar-inner">
            <div className="analytics-survey-title">
              <div
                className="analytics-survey-name"
                dangerouslySetInnerHTML={{ __html: surveyDetails?.SurveyName || "" }}
              />
            </div>
            <div className="analytics-survey-note">
              <SurveyNote end_date={surveyDetails?.ExpiryDate} />
            </div>
          </div>
        </Container>
      </div>
    </div>
  );
};

export default Header;
